import React from "react";
import { useStandUp } from "../contexts/StandUpContext";
import { CheckCircle2, AlertCircle, Info } from "lucide-react";

const Toast: React.FC = () => {
  const { toast } = useStandUp();

  if (!toast) return null;

  const styles = {
    success: "bg-emerald-600 text-white shadow-emerald-600/20",
    error: "bg-red-500 text-white shadow-red-500/20",
    info: "bg-brand-500 text-white shadow-brand-500/20",
  };

  const icons = {
    success: <CheckCircle2 size={18} />,
    error: <AlertCircle size={18} />,
    info: <Info size={18} />,
  };

  return (
    <div className="fixed bottom-6 left-1/2 -translate-x-1/2 z-[200] animate-in fade-in slide-in-from-bottom-4 duration-300">
      <div
        className={`flex items-center gap-3 px-6 py-3 rounded-2xl shadow-2xl font-bold text-sm ${styles[toast.type]}`}
      >
        {icons[toast.type]}
        <span>{toast.message}</span>
      </div>
    </div>
  );
};

export default Toast;
